const eventViewSuccessHubungkanLoyalty = ({
  name,
  email,
  no_hp,
  astraPoint,
}: {
  name: string;
  email: string;
  no_hp: string;
  astraPoint: string;
}) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `success_hubungkan_akun_astrapay`,
      eventCategory: `loyalty digiroom`,
      eventAction: `success hubungkan astrapay`,
      nama: name,
      email: email,
      no_hp: no_hp,
      astraPoint: astraPoint,
    });
  }
};

export default eventViewSuccessHubungkanLoyalty;
